import siteData from "~/src/_data/site.json";

export type SiteData = typeof siteData;

export const useSiteData = () => siteData as SiteData;
